import { cn } from "@/components/podkit/lib/cn";
import type { PropsWithChildren } from "react";

export function StepSubheader({ children, className }: PropsWithChildren<{ className?: string }>) {
    return <h2 className={cn("text-center text-lg text-content-muted", className)}>{children}</h2>;
}
